(function ($) {
    'use strict';
    const keyCodes = {
        Backspace: 8,
        Tab: 9,
        Enter: 13,
        Esc: 27,
        Delete: 46
    };
    $.widget("fd.control_daterangepicker", {
        options: {
            parentid: null,
            callback: function () { },
            mindate: null,
            maxdate: null,
            type: 'single',
            usetime: false,
            predefinedranges: null,
            allownull: false
        },
        _defaultDatepickerOptions: {
            applyClass: 'bg-slate-600',
            cancelClass: 'btn-light',
            autoApply: false
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }
            const datepickerOptions = $.extend({}, this._defaultDatepickerOptions, {
                timePicker: this.options.usetime,
                singleDatePicker: this.options.type === 'single' || false,
                locale: {
                    format: this._formatCode()
                },
                minDate: this.options.mindate || null,
                maxDate: this.options.maxdate || null,
                autoUpdateInput: !this.options.allownull,
                parentEl: this.element.parent()
            });
            if (this.options.predefinedranges) {
                datepickerOptions.ranges = {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                };
            }
            this.element.daterangepicker(datepickerOptions);
            this._setEvents();
        },
        _handleBlur: function (event) {
            const self = event.data;
            if (self.options.allownull && !self.element.val().trim()) {
                self._handleSubmit(null, event);
            }
        },
        _handleKeyup: function (event) {
            const self = event.data;
            if (event.which === keyCodes.Enter) {
                self._handleSubmit(null, event);
            }
        },
        _handleHideDatepicker: function (event, datepicker) {
            const self = event.data;
            if (!self.options.autoUpdateInput) {
                self.element.val(self._getValue(datepicker));
            }
            self._handleSubmit(datepicker, event);
        },
        _handleApplyDatepicker: function (event, datepicker) {
            const self = event.data;
            if (!self.options.autoUpdateInput) {
                self.element.val(self._getValue(datepicker));
            }
            self._handleSubmit(datepicker, event);
        },
        _handleSubmit: function (datepicker, event) {
            if (datepicker) {
                this.options.callback.call(this, {
                    parentid: this.options.parentid,
                    value: this._getValue(datepicker),
                    startDate: datepicker.startDate.format(this._formatCode()),
                    endDate: datepicker.endDate.format(this._formatCode())
                }, event);
            } else {
                this.options.callback.call(this, { parentid: this.options.parentid }, event);
            }
        },
        _setEvents: function () {
            this.element.off('blur.fdcontrol, keyup.fdcontrol, hide.daterangepicker, apply.daterangepicker')
                .on('blur.fdcontrol', null, this, this._handleBlur)
                .on('keyup.fdcontrol', null, this, this._handleKeyup)
                .on('hide.daterangepicker', null, this, this._handleHideDatepicker)
                .on('apply.daterangepicker', null, this, this._handleApplyDatepicker);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        _formatCode: function () {
            return this.options.usetime ? "MM/DD/YYYY h:mm a" : "MM/DD/YYYY";
        },
        _getValue: function (datepicker) {
            if (this.options.type === 'single') {
                return datepicker.startDate.format(this._formatCode());
            }

            return datepicker.startDate.format(this._formatCode()) + '-' + datepicker.endDate.format(this._formatCode());
        }
    });
}(jQuery));